<template>
  <div 
    class="add-on-card"
    :class="{ 'bundle-card': hasDiscount }"
  >
    <div 
      class="product-name-price"
      :class="hasDiscount ? 'bundle-content' : 'default-content'"
    >
      <div :class="{ 'bundle-name': hasDiscount }">
        <div class="name-with-icon">
          <p class="add-on-name">{{ addOnName }}</p>
          <el-tooltip
            v-if="infoIcon"
            effect="dark"
            :content="infoIcon"
            placement="top"
            popper-class="test-info-popover"
            :append-to-body="true"
          >
            <span class="material-icons-outlined info-icon">info</span>
          </el-tooltip>
        </div>
        <div v-if="sampleTypes.length > 0" class="flex items-center gap-2">
          <div v-for="sampleType in sampleTypes" :key="sampleType">
            <TestSampleTypeTagNew :type="sampleType" />
          </div>
        </div>
      </div>
      <div class="button-group">
        <button class="add-button" @click="handleAddClick">
          <span v-if="originalPrice && price < originalPrice">
            {{ `Add for ${currencySymbol}${price} ` }}
            <span class="original-price">{{ `${currencySymbol}${originalPrice}` }}</span>
          </span>
          <span v-else>{{ addButtonText }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TestSampleTypeTagNew from '@/views/va-orderTest/components/TestSampleTypeTagNew.vue';

export default {
  name: 'AddOnCard',
  
  components: {
    TestSampleTypeTagNew
  },

  props: {
    addOnName: {
      type: String,
      default: 'Add-on Name'
    },
    sampleTypes: {
      type: Array,
      default: () => [],
    },
    hasDiscount: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      default: 0
    },
    infoIcon: {
      type: String,
      default: null
    },
    originalPrice: {
      type: Number,
      default: null
    }
  },

  emits: ['add-click'],

  computed: {
    ...mapState(['currency']),
    
    currencySymbol() {
      return this.currency ? this.currency.symbol : '$';
    },
    
    addButtonText() {
      if (this.price > 0) {
        return `Add for ${this.currencySymbol}${this.price}`;
      } else if (this.price === 0) {
        return 'Add for Free';
      } else {
        return `Add and Save ${this.currencySymbol}${Math.abs(this.price)}`;
      }
    }
  },

  methods: {
    handleAddClick() {
      this.$emit('add-click', {
        name: this.addOnName,
        price: this.price,
        hasDiscount: this.hasDiscount
      });
    }
  }
};
</script>

<style scoped>
/* Default variant style (purple) */
.add-on-card {
  background: rgba(250, 246, 255, 0.5);
  border: 1px solid #c8caed;
  border-radius: 6px;
  padding: 12px 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

/* Bundle variant style (orange/peach) */
.bundle-card {
  background: rgba(255, 249, 244, 0.69);
  border: 1.5px solid #f1d5c6;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  height: 86px;
}

.product-name-price {
  width: 100%;
}

.bundle-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.bundle-name {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
}

.default-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.name-with-icon {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.add-on-name {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: #333;
  margin: 0;
  white-space: nowrap;
  font-variation-settings: 'wdth' 100;
}

.info-icon {
  font-size: 18px;
  color: #979797;
}

.button-group {
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
}

.add-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border-radius: 4px;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #1e4670;
  text-align: center;
  white-space: nowrap;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
  background: transparent;
  border: none;
  cursor: pointer;
  min-height: 20px;
}

.add-button:hover {
  opacity: 0.8;
}

.add-button:active {
  opacity: 0.6;
}

.original-price {
  color: #999;
  text-decoration: line-through;
  text-decoration-color: #999;
}
</style>
